import { defineMessages } from 'react-intl';

const messages = defineMessages({
  cta_label: {
    id: 'Botão',
    defaultMessage: 'Botão',
  },
  fullTeaserSize: {
    id: 'Teaser Size',
    defaultMessage: 'Tamanho do Teaser',
  },
});

export const showcaseSchemaEnhancer = ({ schema, formData, intl }) => {
  if (formData?.variation !== 'showcase') {
    return schema;
  }
  const properties = {
    ...schema.properties,
    cta_label: {
      title: intl.formatMessage(messages.cta_label),
      default: 'Acessar',
    },
  };

  if (formData?.variation === 'showcase') {
    properties.styles.schema.properties.align.actions = ['left', 'right'];
  }
  const fieldsets = schema.fieldsets;

  const defaultFieldset = {
    id: 'default',
    title: 'Default',
    fields: [
      'variation',
      'href',
      'overwrite',
      ...(formData?.overwrite
        ? ['head_title', 'title', 'description', 'preview_image', 'cta_label']
        : []),
    ],
  };

  fieldsets.splice(0, 1, defaultFieldset);
  schema = {
    ...schema,
    properties: properties,
    fieldsets: fieldsets,
  };

  return schema;
};

export const fullTeaserSchemaEnhancer = ({ schema, formData, intl }) => {
  if (formData?.variation !== 'fullteaser') {
    return schema;
  }

  const properties = {
    ...schema.properties,
    cta_label: {
      title: intl.formatMessage(messages.cta_label),
      default: 'Acessar',
    },
  };

  if (properties.styles?.schema?.properties) {
    delete properties.styles.schema.properties.align;
    properties.styles.schema.properties.fullTeaserSize = {
      title: intl.formatMessage(messages.fullTeaserSize),
      type: 'string',
      widget: 'image_size',
      default: 'm',
    };
    if (properties.styles?.schema?.fieldsets) {
      properties.styles.schema.fieldsets =
        properties.styles.schema.fieldsets.map((fieldset) => ({
          ...fieldset,
          fields:
            fieldset.fields?.map((field) =>
              field === 'align' ? 'fullTeaserSize' : field,
            ) || [],
        }));
    }
  }

  const fieldsets = schema.fieldsets;

  const defaultFieldset = {
    id: 'default',
    title: 'Default',
    fields: [
      'variation',
      'href',
      'overwrite',
      ...(formData?.overwrite
        ? ['head_title', 'title', 'description', 'preview_image', 'cta_label']
        : []),
    ],
  };

  fieldsets.splice(0, 1, defaultFieldset);
  schema = {
    ...schema,
    properties: properties,
    fieldsets: fieldsets,
  };

  return schema;
};
